import { UseToastOptions } from '@chakra-ui/toast'
import { createElement } from 'react'
import { VibePointsToast } from './VibePointsToast'

export const showVibePointsToast = (
  vibePointsEarned: number | undefined,
  setToast: (options: UseToastOptions) => void,
): void => {
  if (!vibePointsEarned || vibePointsEarned <= 0) return

  setToast({
    duration: 4000,
    position: 'top',
    render: ({ onClose }) =>
      createElement(VibePointsToast, { points: vibePointsEarned, onClose }),
  })
}
